export default __webpack_public_path__ + "static/media/Screen6.e479c8ff.png";